export const ONE_DAY_MS = 1000 * 60 * 60 * 24
export const ONE_YEAR_MS = ONE_DAY_MS * 365
